export default __webpack_public_path__ + "static/media/zendesk.436fa117.svg";